import React from 'react';
import styled from 'styled-components';

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const TextContent = styled.div`
  padding: 24px;
  padding-top: 20px;
  background-color: rgba(250, 249, 246, 0.02);
  width: 100%;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #000;
  width: 100%;
`;

const Description = styled.p`
  color: #666;
  margin: 0;
  line-height: 1.5;
  font-size: 14px;
  width: 100%;
`;

const FeatureImage = styled.div`
  width: 48px;
  height: 48px;
  background-image: ${props => `url(${props.image})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 16px;
  flex-shrink: 0;
`;

const FeatureBox = ({ title, description, image }) => {
  const isValid = typeof image === 'string' && /^https?:\/\//.test(image);
  return (
    <Box>
      {isValid && (
        <StyledImage 
          src={image}
          alt={title}
        />
      )}
      <TextContent>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextContent>
    </Box>
  );
};

export default FeatureBox; 